import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useEffect, useState } from "react"

import { PortalAuthenticator } from "@/features/auth/components/portal-authenticator"
import { refreshAuthTokens } from "@/lib/auth/auth-store"

export const Route = createFileRoute("/")({
	component: LoginPage,
})

function LoginPage() {
	return (
		<div className="flex min-h-dvh flex-col items-center bg-sidebar px-4 py-10">
			<div className="my-auto w-full max-w-md">
				<div className="mb-8 text-center">
					<div className="mx-auto mb-4 h-16 w-16">
						<img src="/images/spray-pattern-white.svg" alt="OptiMist" width={64} height={64} />
					</div>
					<h1 className="font-avenir text-page-title font-semibold text-white">
						OptiMist Admin
					</h1>
					<p className="mt-2 font-inter text-body text-gray-400">
						Sign in to access the admin portal
					</p>
				</div>
				<div className="overflow-hidden rounded-2xl bg-white p-8">
					<PortalAuthenticator>
						{() => <PostLoginRedirect />}
					</PortalAuthenticator>
				</div>
			</div>
		</div>
	)
}

export function PostLoginRedirect() {
	const navigate = useNavigate()
	const [error, setError] = useState<string | null>(null)

	useEffect(() => {
		let active = true
		void refreshAuthTokens()
			.then((tokens) => {
				if (!active) return
				if (tokens === null) {
					setError("Unable to complete sign in. Please refresh and try again.")
					return
				}
				return navigate({ to: "/dashboard" })
			})
			.catch(() => {
				if (!active) return
				setError("Unable to complete sign in. Please refresh and try again.")
			})

		return () => {
			active = false
		}
	}, [navigate])

	if (error) {
		return (
			<div
				className="mt-4 rounded-xl border border-destructive/40 bg-destructive/10 px-4 py-3 text-meta text-destructive"
				role="alert"
			>
				{error}
			</div>
		)
	}

	return (
		<div className="mt-4 flex items-center justify-center text-meta text-muted-foreground">
			Redirecting…
		</div>
	)
}
